/**
 * A strong password to suggest when an approver's SAP B1 password has expired.
 * Uses the browser's cryptographic random generator; mixes upper/lower case,
 * digits and symbols (at least two of each) and leaves out look-alikes
 * (I, l, O, 0, 1). SAP's own password policy still decides; if it refuses,
 * its message is shown and the user can edit or regenerate.
 */
const UPPER = 'ABCDEFGHJKLMNPQRSTUVWXYZ';
const LOWER = 'abcdefghijkmnopqrstuvwxyz';
const DIGITS = '23456789';
const SYMBOLS = '!@#$%*-_+=?';

function pick(set: string, rand: Uint32Array, i: number): string {
  return set[rand[i] % set.length];
}

export function generateSapPassword(length = 14): string {
  const n = Math.max(12, Math.min(32, length));
  const rand = new Uint32Array(n * 2);
  window.crypto.getRandomValues(rand);
  const all = UPPER + LOWER + DIGITS + SYMBOLS;
  const chars = [
    pick(UPPER, rand, 0), pick(UPPER, rand, 1),
    pick(LOWER, rand, 2), pick(LOWER, rand, 3),
    pick(DIGITS, rand, 4), pick(DIGITS, rand, 5),
    pick(SYMBOLS, rand, 6), pick(SYMBOLS, rand, 7),
  ];
  for (let i = chars.length; i < n; i++) chars.push(pick(all, rand, i));
  // Fisher–Yates shuffle with the second half of the random values.
  for (let i = chars.length - 1; i > 0; i--) {
    const j = rand[n + i] % (i + 1);
    [chars[i], chars[j]] = [chars[j], chars[i]];
  }
  return chars.join('');
}
